import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NavigateToWebApps from '../utils/NavigateToWebApps';

function RequiresAuthenticatedUser(WrappedComponent) {
  return class extends Component {
    static propTypes = {
      location: PropTypes.shape({
        action: PropTypes.string,
      }),
      session: PropTypes.shape({
        authenticated: PropTypes.bool,
      }),
    };

    componentDidMount() {
      const { session, location } = this.props;
      if (
        !session ||
        (session && !session.authenticated) ||
        (location && location.action === 'POP')
      ) {
        NavigateToWebApps.navigateToLoginPage();
      }
    }

    componentDidUpdate() {
      if (!this.props.session || !this.props.session.authenticated) {
        NavigateToWebApps.navigateToLoginPage();
      }
    }

    render() {
      return this.props.session && this.props.session.authenticated ? (
        <WrappedComponent {...this.props} />
      ) : (
        <div />
      );
    }
  };
}

export { RequiresAuthenticatedUser };
